import React from 'react';
import { Container, makeStyles } from '@material-ui/core';

import { ProductPreview } from 'domain/types';
import ProductCard from '../ProductCard/ProductCard';

interface ProductTilesProps {
  products: ProductPreview[];
}

const ProductTiles: React.FC<ProductTilesProps> = ({ products }): JSX.Element => {
  const classes = useStyles();

  return (
    <Container id="product-list" className={classes.container}>
      <div className={classes.gridCointainer}>
        {products.map((product, index) => (
          <article key={product.sys.id}>
            <ProductCard product={product} index={index} />
          </article>
        ))}
      </div>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.only('xs')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  },
  gridCointainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumn: '1fr',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr 1fr'
    },
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(5)
    }
  }
}));

export default ProductTiles;
